const r = (o, e) => e.some((n) => new RegExp(`^${n.replace(/\*/g, ".*")}$`).test(o)), l = (o = "", e) => e.includes(o), d = (o, e) => {
  const n = `.${o.name.split(".").pop()}`, t = o.type;
  return l(n, e) || r(t, e);
}, i = (o) => {
  try {
    const e = document.createElement("a");
    e.href = o, e.rel = "noopener", e.style.display = "none", document.body.appendChild(e), e.click(), document.body.removeChild(e);
  } catch (e) {
    throw console.error("Failed to download file:", e), new Error("Failed to download file");
  }
};
export {
  i as downloadFile,
  l as validateFileExtension,
  d as validateFileFormat,
  r as validateFileTypes
};
//# sourceMappingURL=index.es735.js.map
